"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React from "react";
import classNames from "classnames";
import { IconSize } from "../types";
import * as styles from "../Icons-css";
const Settings = (props) => {
  const _a = props, { className, size = IconSize.Medium, color = "inherit" } = _a, rest = __objRest(_a, ["className", "size", "color"]);
  const iconClass = classNames(
    styles.icon({
      size,
      color
    }),
    "kl-icon",
    `kl-icon--${size}`,
    className
  );
  return React.createElement(
    "svg",
    __spreadValues({ width: "24", height: "24", viewBox: "0 0 24 24", className: iconClass }, rest),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        d: "M11 1a1 1 0 00-1 1v2.252a7.952 7.952 0 00-2.064.856L6.343 3.515a1 1 0 00-1.414 0L3.515 4.929a1 1 0 000 1.414l1.593 1.593A7.952 7.952 0 004.252 10H2a1 1 0 00-1 1v2a1 1 0 001 1h2.252c.189.734.48 1.427.856 2.064l-1.593 1.593a1 1 0 000 1.414l1.414 1.414a1 1 0 001.414 0l1.593-1.593c.637.377 1.33.667 2.064.856V22a1 1 0 001 1h2a1 1 0 001-1v-2.252a7.957 7.957 0 002.064-.856l1.593 1.593a1 1 0 001.414 0l1.414-1.414a1 1 0 000-1.414l-1.593-1.593c.377-.637.667-1.33.856-2.064H22a1 1 0 001-1v-2a1 1 0 00-1-1h-2.252a7.957 7.957 0 00-.856-2.064l1.593-1.593a1 1 0 000-1.414l-1.414-1.414a1 1 0 00-1.414 0l-1.593 1.593A7.952 7.952 0 0014 4.252V2a1 1 0 00-1-1h-2zm4 11a3 3 0 11-6 0 3 3 0 016 0z"
      }
    )
  );
};
export default Settings;
